export {
    ScoreSummaryCard,
    ScoreSummaryCard as default,
} from './ScoreSummaryCard'
export type { WinState } from './ScoreSummaryCard.styled'
